/**
 * Lightweight GA4 event helper.
 *
 * Fires a custom event through the global gtag (set up in app/layout.tsx).
 * Safe no-op when gtag isn't available — during SSR, before the GA script
 * has loaded, or when a visitor blocks analytics. Never throws, so it can be
 * dropped onto any onClick without guarding the call site.
 *
 * Key events to mark in GA4 (Admin → Events → "Mark as key event"):
 *   - contact        (email / phone / WhatsApp click)   ← primary
 *   - cv_download     (CV / resume opened)               ← primary
 *   - project_visit   (outbound click to a live project)
 *   - social_click    (GitHub / LinkedIn / X / etc.)     ← secondary
 */
type GtagParams = Record<string, string | number | boolean>

export function track(event: string, params: GtagParams = {}): void {
  if (typeof window === 'undefined') return
  const w = window as unknown as { gtag?: (...args: unknown[]) => void }
  if (typeof w.gtag !== 'function') return
  w.gtag('event', event, params)
}
